import React from 'react'
import { arrayOf, number, shape, string } from 'prop-types'

import styles from './AdvertiseTestimonial.module.scss'
import ResponsiveImage from '@/component/Primitive/ResponsiveImage'
import Type from '@/component/Primitive/Type'
import Icon from '@/component/Primitive/Icon'
import Container from '@/component/Primitive/Container'
import classNames from 'classnames'
import Prose from '@/component/Primitive/Prose'
import Hide from '@/component/Primitive/Hide'
import ChevronTitle from '@/component/Primitive/ChevronTitle'

const AdvertiseTestimonial = ({ description, quote, image }) => {
  const { mobile: mobileImage, desktop: desktopImage } = image
  const { text: quoteText, attribution, secondaryAttribution, brand } = quote

  return (
    <div className={styles.AdvertiseTestimonial}>
      <div className={styles.About}>
        <Container className={styles.AboutContainer} gutter>
          <ChevronTitle title="About" />
          <Prose className={styles.Description} dangerousHtml={description} />
        </Container>
      </div>

      <div className={styles.Quote}>
        <Hide at="desktop">
          <ResponsiveImage
            className={classNames(styles.Image, styles.mobileImage)}
            {...mobileImage}
            loading="eager"
          />
        </Hide>
        <Hide below="desktop">
          <ResponsiveImage
            className={classNames(styles.Image, styles.desktopImage)}
            {...desktopImage}
            loading="eager"
          />
        </Hide>
        <blockquote className={styles.Blockquote}>
          <Container className={styles.BlockquoteContainer} gutter>
            <Type as="p" size={['body2', 'body1']}>
              <Icon
                type="quotationMarks"
                width={63}
                height={49}
                className={styles.BlockquoteQuotationMarks}
              />
              {quoteText}
            </Type>
            <div className={styles.BlockquoteFooter}>
              <img loading="lazy" src={brand.logo} alt={brand.name} />
              <div className={styles.BlockquoteAttribution}>
                <Type
                  className={styles.Attribution}
                  size={['body2', 'body1']}
                  weight="medium"
                >
                  {attribution}
                </Type>
                <Type
                  className={styles.SecondaryAttribution}
                  size={['body2', 'body1']}
                >
                  {secondaryAttribution}
                </Type>
              </div>
            </div>
          </Container>
        </blockquote>
      </div>
    </div>
  )
}

AdvertiseTestimonial.propTypes = {
  description: string,
  quote: shape({
    text: string,
    attribution: string,
    secondaryAttribution: string,
    brand: shape({
      name: string,
      logo: string
    })
  }),
  image: shape({
    mobile: shape({
      src: string,
      srcSet: arrayOf(shape({ width: number, src: string })),
      sizes: arrayOf(string)
    }),
    desktop: shape({
      src: string,
      srcSet: arrayOf(shape({ width: number, src: string })),
      sizes: arrayOf(string)
    })
  })
}

export default AdvertiseTestimonial
